import * as ReactJsPopUp from 'reactjs-popup';
import styled from 'styled-components';

const Popup = styled(ReactJsPopUp.Popup)`
  // use your custom style for ".popup-overlay"
  &-overlay {
  }
  // use your custom style for ".popup-content"
  &-content {
    padding: 10px 20px;
    width: 300px;
    background-color: #fff;

    font-weight: 600;
    box-shadow: 0px 0px 10px 0px #ddd;
  }

  &.errors {
    padding: 0 0 15px 0;
    background: none;
    box-shadow: none;

    width: 340px;
    transform: translate(-50%, -0px);
    // border-bottom: 10px solid rgba(0,0,0,0);
    margin-bottom: 10px;
  }

  .helptip-scrollable-wrapper {
    padding: 15px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px #ddd;
  }

  .helptip-scrollable {
    height: 200px;
    overflow: auto;
  }

  ul,
  ol {
    padding: 0 20px;
    li {
      text-align: left;
      margin-bottom: 5px;
    }
  }

  > span {
    text-align: center;
  }
`;

export {Popup};
